<script lang="ts" setup>
import { sleep } from '@antfu/utils'
import { useAPIHandle } from 'core'
import { FormResult, useForm } from '../state'

const form = useForm()
const isValid = computed(() => FormResult.safeParse(form.state).success)

const [uploadState, upload, reset] = useAPIHandle(async () => {
  const success = await form.upload()

  // Reset after 2s
  if (success) {
    sleep(2000).then(() => {
      reset()
      form.reset()
    })
  }

  return success
})
</script>

<template>
  <section>
    <form class="gap-4 grid grid-cols-[1fr_max-content] grid-rows-[48px]" @submit.prevent="upload">
      <input
        v-model.trim="form.state.email"
        name="input"
        type="email"
        required
        :placeholder="form.strings.emailInputPlaceholder"
        class="text-$color-neutral placeholder:text-$color-neutral placeholder:opacity-60 bg-transparent border-$color-neutral-border focus:border-$color-primary"
      >

      <CTAButton
        :loading="uploadState.loading"
        :disabled="!isValid"
        class="icon-button"
        variant="primary"
        size="base"
        type="submit"
        title="Submit"
      >
        <Icon v-if="uploadState.result === false" name="solar:danger-circle-bold" />
        <Icon v-else-if="!isValid" name="solar:plain-broken" />
        <Icon v-else name="solar:plain-bold" />
      </CTAButton>
    </form>

    <!-- Success overlay -->
    <Transition name="fade-in">
      <div v-if="uploadState.result === true" aria-label="Successful" class="z-10 absolute inset-0 flex-center bg-$color-background">
        <Icon name="solar:check-circle-linear" class="text-$color-primary text-80px" />
      </div>
    </Transition>
  </section>
</template>
